import { useMutation } from "@tanstack/react-query";

import cookiesHelper from "../../helpers/cookies";

import useSignOut from "./useSignOut";
import api from "../apiClient";

export interface IPayload {
    setIsProcessing: Function;
    setToken: Function;
    onClose: Function;
};

interface IResponse {
    error?: string;
    message: string;
    data: string;
};

const useRefreshAuthToken = () => {
    const { mutate: signOut } = useSignOut();

    const mutationFn = async (data: IPayload): Promise<any> => {
        const token = cookiesHelper.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`users/refresh-token`);
        return res.data;
    }

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
        },
        onSuccess: (data: any, variables: IPayload) => {
            cookiesHelper.setCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string, data.data, 60 * 60 * 1000);
            variables.setToken(data.data);
            variables.onClose();
        },
        onError: (error: IResponse, variables: IPayload) => {
            signOut();
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    })
};
export default useRefreshAuthToken;